import { useOutletContext } from 'react-router-dom'
import { Funcionario, TabelaHorarios } from 'service/api'

export function useFuncionariosOutletContext() {
    return useOutletContext<{
        data?: Array<
            Funcionario & {
                TabelaHorario?: TabelaHorarios
                temAjustesPendentes?: boolean
            }
        >
        refetch?: () => Promise<unknown>
    }>()
}
